module.exports = __webpack_public_path__ + "img/freelance-avatar.ca6b8f66.png";